/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { isType } from 'typescript-fsa';
import { setHtmlInclude } from './actions';
import { Action } from 'redux';

export interface HtmlIncludeState {
    includeData: {[url: string]: string};
}

export const initialHtmlIncludeState: HtmlIncludeState = {
    includeData: {}
};

export function htmlIncludeReducer (state: HtmlIncludeState = initialHtmlIncludeState, action: Action) {

    if (isType(action, setHtmlInclude)) {
        let url = action.payload.url;
        let content = action.payload.content;
        let newMap = Object.assign({}, state.includeData);
        newMap[url] = content;

        return Object.assign({}, state, {includeData: newMap});
    }

    return state;
}